/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Load_Starred_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to load starred files" |
*
* @param {Explorer_Nav_Load_Starred_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_load_starred_failed_toast = /** @type {((inputs?: Explorer_Nav_Load_Starred_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Load_Starred_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec du chargement des fichiers favoris")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die markierten Dateien konnten nicht geladen werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare i file contrassegnati con una stella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось загрузить файлы, отмеченные звездочкой.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudieron cargar los archivos destacados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载星标文件失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スター付きファイルの読み込みに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तारांकित फ़ाइलों को लोड करने में विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao carregar arquivos com asterisco")
	return /** @type {LocalizedString} */ ("Failed to load starred files")
});